<template>
    <div>
        <navbar></navbar>
        <!--END Navbar-->

        <b-card>
            <b-tabs content-class="mt-3">
                <b-tab title="Information" active>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Nutzername
                        <span>{{user.name}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Email
                        <span>{{user.email}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        status
                        <span>{{user.status}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        birth day
                        <span>{{user.birth_day}} / {{user.birth_month}} / {{user.birth_year}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        register date
                        <span>{{registerDate}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Treuepunkte


                        <span>

                            <b-input-group class="mt-3">
                                <b-form-input type="number" v-model="form.wallet"></b-form-input>
                            </b-input-group>
                        </span>
                    </li>

                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Promotion Percent
                        <span>
                            <b-input-group class="mt-3">
                                <b-form-input type="number" v-model="form.promotionPercent"></b-form-input>
                            </b-input-group>
                        </span>
                    </li>

                    <b-button @click="updateUser" variant="success">save</b-button>
                </b-tab>
                <b-tab title="address">
                    <ul class="list-group mt-4" v-for="(address,index) in addresses" :key="index">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            {{address.gender}} {{address.first_name}}
                            {{address.last_name}}
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            {{address.street}} {{address.additional}}
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            {{address.post_code}} {{address.city}}
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            {{address.country}}
                        </li>
                    </ul>
                </b-tab>
                <b-tab>
                    <template #title>
                        <span class="mr-2">Orders</span>
                        <span>
                            <b-badge variant="danger">{{orders.length}}</b-badge>
                        </span>
                    </template>


                    <b-table-simple>
                        <b-thead>
                            <b-tr>
                                <b-th>BESTELLNUMMER</b-th>
                                <b-th>PRISE</b-th>
                                <b-th>DATUM</b-th>
                            </b-tr>
                        </b-thead>

                        <b-tbody v-if="orders !== null && orders.length > 0">
                            <b-tr :key="index" v-for="(order,index) in orders">
                                <b-td>
                                    <router-link class="text-primary" :to="{name:'OrderDetails',params:{'orderid':order.id}}">{{order.code}}</router-link>
                                </b-td>
                                <b-td>{{order.price}}</b-td>
                                <b-td>{{order.date}}</b-td>
                            </b-tr>
                        </b-tbody>

                    </b-table-simple>

                </b-tab>
                <b-tab title="payments">
                    <template #title>
                        <span class="mr-2">Payments</span>
                        <span>
                            <b-badge variant="danger">{{payments.length}}</b-badge>
                        </span>
                    </template>

                    <b-table :fields="table.fieldsPayments" :items="payments"></b-table>


                </b-tab>
            </b-tabs>
        </b-card>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'


    export default {
        name: "Details",
        components: {Navbar},
        data() {
            return {
                user: null,
                registerDate: null,
                addresses: [],
                orders: [],
                payments: [],
                form: {
                    wallet: 0,
                    promotionPercent: 0,
                },
                table: {
                    fieldsOrders: [
                        {
                            key: 'code',
                            label: 'BESTELLNUMMER'
                        },
                        {
                            key: 'price',
                            label: 'PRISE'
                        },
                        {
                            key: 'date',
                            label: 'DATUM'
                        },

                    ],
                    fieldsPayments: [
                        {
                            key: 'order_tracking_number',
                            label: 'BESTELLNUMMER'
                        },
                        {
                            key: 'status',
                            label: 'STATUS'
                        },
                        {
                            key: 'heidey_id',
                            label: 'HEIDELPAY ID'
                        },
                        {
                            key: 'date',
                            label: 'DATUM'
                        },
                    ]
                }
            }
        },
        methods: {
            getUser() {
                if (this.$route.params.userid && this.$route.params.userid > 0) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'user/show/' + this.$route.params.userid)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.user = response.data.data.user;
                                this.registerDate = response.data.data.register_date;
                                this.addresses = response.data.data.addresses;
                                this.orders = response.data.data.orders;
                                this.payments = response.data.data.payments;

                                this.form.wallet = this.user.wallet;
                                this.form.promotionPercent = this.user.promotion_percent;

                            } else {
                                Notification.error(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            },
            updateUser() {
                if (this.$route.params.userid && this.$route.params.userid > 0) {
                    this.$Progress.start();
                    Http.post(Http.apiurlV2() + 'user/update/' + this.$route.params.userid,this.form)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                Notification.success(response.data.message)
                            } else {
                                Notification.error(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            }
        },
        created() {
            this.getUser();
        }
    }
</script>

<style scoped>

</style>